const ConstructionStage = {

    "stage_name": "Stage Name",
    "description": "Description",
    "priority": "Priority",
    "status": "Status",
    "search": "Search",

    "constructionStage": "Construction Stage",

    "error_stage_name": "Enter Stage Name",
    "error_description": "Enter Description",
    "error_priority_positive": "Priority Should be Positive",
    "error_priority_required": "Enter Priority",
    "error_status": "Select Status",

    "table_stage_name": "STAGE NAME",
    "table_description": "DESCRIPTION",
    "table_priority": "PRIORITY",
    "table_status": "STATUS",

}

export default ConstructionStage;
